//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { queryQtLqxxList } from '@/https/crEnroll'

export default {
  components: {},

  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      enrollList: [],
      enrollResult: {},
      emptyMsg:
        '你好，系统未查询到你的录取结果，你可能未被录取或者学校还未发布录取结果！',
    }
  },

  computed: {
    styleBg () {
      const str =
        this.options && this.options.bjImg
          ? `url('${this.options.bjImg}')`
          : ''

      return `backgroundImage: ${str}`
    },
  },

  watch: {
    options: {
      handler (val) {
        if (val) {
          this.setEnrollResult()
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async setEnrollResult () {
      const { data } = await queryQtLqxxList({
        ksh: this.options.ksh?.trim(),
        zjhm: this.options.zjhm?.trim(),
        xm: this.options.xm?.trim(),
      })

      this.enrollList = data || []
    },

    closeDrawer () {
      this.$emit('on-close')
    },
  },
}
